// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-spacer[data-v-7fbc8b24]{margin:0!important;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.page-spacer+*[data-v-7fbc8b24]{margin-left:0!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
